module.exports = __webpack_public_path__ + "images/apple-touch-icon-60x60.7d1d76665aebe222d133257909b8aa66.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/favicons/apple-touch-icon-60x60.png
// module id = 994
// module chunks = 0